import { Reveal } from "@/components/Reveal";
import { PARTNER_FORM_URL } from "@/constants";

const audiences = [
    { numeral: "I", name: "Industry Freelancers", testid: "partner-audience-freelancers" },
    { numeral: "II", name: "Commercial Directors", testid: "partner-audience-directors" },
    { numeral: "III", name: "Agency Creative Leads", testid: "partner-audience-agencies" },
    { numeral: "IV", name: "Production Houses", testid: "partner-audience-production-houses" },
];

const Partnerships = () => (
    <section
        id="partnerships"
        data-testid="partnerships-section"
        className="relative overflow-hidden px-6 py-32 sm:py-40 lg:px-16 lg:py-48"
    >
        <div className="royal-flare absolute inset-x-0 top-0 h-[55vh] opacity-70" />

        <div className="relative mx-auto max-w-4xl text-center">
            <Reveal>
                <p className="mb-8 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    Partnership Program
                </p>
                <h2
                    data-testid="partnerships-title"
                    className="font-serif text-4xl font-normal leading-[1.1] tracking-[-0.01em] text-[#270057] sm:text-5xl lg:text-6xl"
                >
                    The Vellor Ecosystem:{" "}
                    <em className="italic">Strategic Partnerships</em>
                </h2>
                <div className="royal-rule mx-auto mt-12 w-32" />
                <p
                    data-testid="partnerships-copy"
                    className="mx-auto mt-10 max-w-2xl text-base font-normal leading-relaxed text-[#270057] sm:text-lg"
                >
                    Vellor Studio operates as a collaborative hub for the
                    industry's finest. We invite qualified industry freelancers,
                    commercial directors, agency creative leads, and production
                    houses to partner with our facility — gaining robust
                    technical infrastructure, disciplined timelines, and a
                    post-production partner that scales seamlessly with your
                    project's demands.
                </p>
            </Reveal>

            <div className="mt-20 grid grid-cols-2 gap-px border border-[#270057]/15 bg-[#270057]/15 lg:mt-24 lg:grid-cols-4">
                {audiences.map((a, i) => (
                    <Reveal key={a.testid} delay={i * 0.1}>
                        <div
                            data-testid={a.testid}
                            className="group flex h-full flex-col items-center bg-white px-6 py-10 transition-colors duration-700"
                        >
                            <span className="font-serif text-lg italic text-[#270057] transition-colors duration-700 group-hover:text-[#270057]">
                                {a.numeral}.
                            </span>
                            <span className="mt-4 font-display text-[10px] uppercase tracking-[0.25em] text-[#270057]">
                                {a.name}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div className="mt-16">
                    <a
                        href={PARTNER_FORM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="apply-partner-button"
                        className="btn-royal inline-block rounded-full px-12 py-5 font-display text-[11px] font-semibold uppercase tracking-[0.3em]"
                    >
                        Apply as a Partner
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Partnerships;
